module.exports = __webpack_public_path__ + "static/media/frontphone-newsletter-medium.ecccf76d.png";